import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.ApproveExpensePresenter`

export default defineMessages({
  approveSuccess: {
    id: `${scope}.approveSuccess`,
    defaultMessage: 'Expense report #{expenseId} approved',
  },
  approveError: {
    id: `${scope}.approveError`,
    defaultMessage: "Expense report couldn't be approved",
  },
})
